import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Loading } from '../components/loading.js';
import { Turl } from '../components/tUrl.js'
import '../css/trade.css'; // Common styles for info blocks
import { formatNumberWithCommas } from '../components/formatIntegerWithCommas.js'
import { t } from 'ttag';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';

DataTable.use(DT);

const tg = window.Telegram ? window.Telegram.WebApp : null;

function Trade({ recData, handlesetIndex }) {
    const [mData, setmData] = useState(null);
    const [activeTab, setActiveTab] = useState('crypto');
    const [forexAccounts, setForexAccounts] = useState([]);
    const [newAccount, setNewAccount] = useState('');
    const [loadingForex, setLoadingForex] = useState(false);
    const hasFetchedData = useRef(false);

    const [showRefModal, setShowRefModal] = useState(false);
    const [refDateFrom, setRefDateFrom] = useState('');
    const [refDateTo, setRefDateTo] = useState('');
    const [refData, setRefData] = useState(null);
    const [refLoading, setRefLoading] = useState(false);
    const [refError, setRefError] = useState('');

    const getInitData = () => tg ? tg.initData : null;

    const fetchReferrals = useCallback(async (dateFrom, dateTo) => {
        setRefLoading(true);
        setRefError('');
        try {
            const response = await fetch(Turl + '/st/trade/referrals', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    initData: getInitData(),
                    dateFrom: dateFrom || undefined,
                    dateTo: dateTo || undefined
                })
            });

            if (response.ok) {
                const res = await response.json();
                if (res.success && res.data) {
                    setRefData(res.data);
                } else if (Array.isArray(res.referrals) || res.totalCommission !== undefined) {
                    setRefData(res);
                } else {
                    setRefData(res.data || res);
                }
            } else {
                setRefError(t`Failed to load referral data`);
            }
        } catch (error) {
            console.error('Error fetching referrals:', error);
            setRefError(t`Error connecting to server`);
        } finally {
            setRefLoading(false);
        }
    }, []);

    const handleOpenRefModal = () => {
        setShowRefModal(true);
        fetchReferrals(refDateFrom, refDateTo);
    };
    useEffect(() => {
        const getData = async () => {
            hasFetchedData.current = true;

            try {
                const _userData = getInitData();
                let userData = { initData: _userData }

                if (userData) {
                    const response = await fetch(Turl + '/st/trade', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(userData)
                    });

                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    let rd = await response.json();
                    for (let index = 0; index < rd.data.orders.length; index++) {
                        const element = rd.data.orders[index];
                        const date = new Date(parseInt(element.dt));
                        const dt = date.toLocaleString();
                        element.dt = ("" + dt).replace(",", "</br>");
                        element.profit = parseFloat(element.profit).toFixed(2)
                        if (element.price > 1000) {
                            element.price = parseFloat(element.price).toFixed(2)
                            element.priceClose = parseFloat(element.priceClose).toFixed(2)
                        } else {
                            element.price = parseFloat(element.price).toFixed(4)
                            element.priceClose = parseFloat(element.priceClose).toFixed(4)
                        }
                    };

                    setmData(rd)
                } else {
                    console.warn("Telegram user data not available.");
                }

            } catch (error) {
                console.error('Authentication error:', error);
            }
        };

        if (!mData && !hasFetchedData.current) {
            getData();
        }
    }, [mData]);

    // --- Загрузка форекс-счетов ---
    const fetchForexAccounts = useCallback(async () => {
        setLoadingForex(true);
        try {
            const response = await fetch(Turl + '/st/forex/accounts', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ initData: getInitData() })
            });
            if (response.ok) {
                const data = await response.json();
                setForexAccounts(data.accounts || []);
            }
        } catch (error) {
            console.error('Error fetching forex accounts:', error);
        } finally {
            setLoadingForex(false);
        }
    }, []);

    useEffect(() => {
        if (activeTab === 'forex') {
            fetchForexAccounts();
        }
    }, [activeTab, fetchForexAccounts]);

    // --- Добавить счёт ---
    const handleAddAccount = async () => {
        if (!newAccount.trim()) return;
        try {
            const response = await fetch(Turl + '/st/forex/add-account', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ initData: getInitData(), account: newAccount.trim() })
            });
            if (response.ok) {
                setNewAccount('');
                fetchForexAccounts();
            } else {
                const err = await response.json();
                alert(err.message || 'Error adding account');
            }
        } catch (error) {
            console.error('Error adding account:', error);
        }
    };

    // --- Удалить счёт ---
    const handleDeleteAccount = async (accountId, accountNumber) => {
        if (!window.confirm(t`Are you sure you want to delete account ${accountNumber}?`)) {
            return;
        }
        try {
            const response = await fetch(Turl + '/st/forex/delete-account', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ initData: getInitData(), accountId })
            });
            if (response.ok) {
                fetchForexAccounts();
            }
        } catch (error) {
            console.error('Error deleting account:', error);
        }
    };

    // --- Копировать ссылку и открыть ---
    const handleActionClick = (link) => {
        const _tg = window.Telegram ? window.Telegram.WebApp : null;
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(link).then(() => {
                if (_tg) {
                    _tg.showAlert(t`Link copied!`);
                } else {
                    alert(t`Link copied!`);
                }
            }).catch(err => {
                console.error('Не удалось скопировать:', err);
            });
        } else {
            // Fallback for non-secure contexts (e.g. HTTP)
            const textArea = document.createElement("textarea");
            textArea.value = link;
            textArea.style.position = "fixed";  // Avoid scrolling to bottom
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
                if (_tg) {
                    _tg.showAlert(t`Link copied!`);
                } else {
                    alert(t`Link copied!`);
                }
            } catch (err) {
                console.error('Не удалось скопировать:', err);
            }
            document.body.removeChild(textArea);
        }

        // Открываем ссылку
        if (_tg && _tg.openLink) {
            _tg.openLink(link);
        } else {
            window.open(link, '_blank');
        }
    };


    if (!mData && activeTab === 'crypto')
        return <Loading />;
    if (activeTab === 'crypto') {
        hasFetchedData.current = false;
    }

    // === ВКЛАДКИ ===
    const tabs = (
        <div className="t-tabs-container">
            <button
                className={`t-tab ${activeTab === 'crypto' ? 'active' : ''}`}
                onClick={() => setActiveTab('crypto')}
            >
                {t`Crypto`}
            </button>
            <button
                className={`t-tab ${activeTab === 'forex' ? 'active' : ''}`}
                onClick={() => setActiveTab('forex')}
            >
                {t`Forex`}
            </button>
        </div>
    );

    // === КРИПТО КОНТЕНТ ===
    const bal = (
        <>
            <div className="trade-block t-balance-card">
                <div className="t-balance-label">{t`Trade balance`}</div>
                <div className="profit t-balance-value">{formatNumberWithCommas(recData.trade_balance, 2)} USDT</div>
            </div>
            <div className="t-button-container">
                <button className="t-action-button" onClick={() => { handlesetIndex(21) }}>
                    {t`Deposit`}
                </button>
                <button className="t-action-button" onClick={() => { handlesetIndex(22) }}>
                    {t`Withdrawal`}
                </button>

            </div>
        </>
    );

    const stat = (
        <div className='trade-block' style={{ padding: "0px" }}>
            <div style={{ padding: "16px" }}>
                <div className='t-block-title' style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}>
                    <div>{t`Statistics`}</div>
                    <div><a className="t-action-button-a" href='https://coinstats.app/p/D2EqgrUe7lp3nlv/'>
                        {t`Monitor`}
                    </a></div>
                </div>
                <div className="t-data-row">
                    <div className="t-data-label">{t`Day profit`}</div>
                    <div className="profit t-data-value">
                        {formatNumberWithCommas(mData.data.profit_day, 5)} USDT
                    </div>
                </div>
                <div className="t-data-row">
                    <div className="t-data-label">{t`Total profit`}</div>
                    <div className="profit t-data-value">
                        {formatNumberWithCommas(mData.data.profit_total, 5)} USDT
                    </div>
                </div>
                <div className="t-data-row">
                    <div className="t-data-label">{t`Used deposit`}</div>
                    <div className="t-data-value">
                        {parseFloat(mData.data.dep_use).toFixed(2)} %
                    </div>
                </div>
                <div className="t-data-row">
                    <div className="t-data-label">{t`Equity`}</div>
                    <div className="t-data-value">
                        {parseFloat(mData.data.equity).toFixed(2)} USDT
                    </div>
                </div>
            </div>
            <div className="table-responsive" style={{ borderTop: "2px solid #171c24" }}>
                <DataTable
                    data={mData.stat}
                    className="display dark cell-border compact stripe"
                    options={{
                        searching: false,
                        autoWidth: true,
                        layout: { topStart: null },
                        order: [[0, 'desc']],
                        paging: false,
                        info: false,
                    }}
                    columns={[
                        { data: 'formatted_date', className: 'tbl-center' },
                        { data: 'total_profit', className: 'profit-green tbl-center' },
                    ]}
                >
                    <thead>
                        <tr>
                            <th>{t`Day`}</th>
                            <th style={{ width: "20%" }}>{t`profit`}</th>


                        </tr>
                    </thead>
                </DataTable>
            </div>
        </div>
    );

    const trd = (
        <div className="tTHDataTable">
            <div style={{ textAlign: "center" }}>{t`Last closed deals`}</div>
            <div className="table-responsive">
                <DataTable
                    data={mData.data.orders}
                    className="display dark cell-border compact stripe"
                    options={{
                        searching: false,
                        autoWidth: true,
                        layout: { topStart: null },
                        order: [[1, 'desc']],
                    }}
                    columns={[
                        { data: 'symbol' },
                        { data: 'dt' },
                        { data: 'price' },
                        { data: 'priceClose' },
                        {
                            data: 'profit',
                            className: 'profit-green'
                        },
                    ]}
                >
                    <thead>
                        <tr>
                            <th>{t`symbol`}</th>
                            <th style={{ width: "30%" }}>{t`date`}</th>
                            <th style={{ width: "10%" }}>{t`price`}</th>
                            <th style={{ width: "10%" }}>{t`price close`}</th>
                            <th style={{ width: "10%" }}>{t`profit`}</th>
                        </tr>
                    </thead>
                </DataTable>
            </div>
        </div>
    );

    const getStatusText = (status) => {
        switch (status) {
            case 'approved': return t`Approved`;
            case 'rejected': return t`Rejected`;
            case 'pending':
            default: return t`Pending`;
        }
    };

    const getStatusIcon = (status) => {
        switch (status) {
            case 'approved': return <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2ecc71" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>;
            case 'rejected': return <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#e74c3c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>;
            case 'pending':
            default: return <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#f39c12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>;
        }
    };

    // === ФОРЕКС КОНТЕНТ ===
    const forexContent = (
        <div className="t-forex-content">
            {/* Кнопки Подключиться и Стратегия */}
            <div className="t-button-container">

                <button
                    className="t-action-button"
                    onClick={() => handleActionClick('https://my.roboforex.com/ua/?a=walzo')}
                >
                    {t`Connect`}
                </button>
                <button
                    className="t-action-button"
                    onClick={() => handleActionClick('https://roboforex.com/copy-trading/rating/bbba/37310586')}
                >
                    {t`Strategy`}
                </button>

                <button className="t-action-button" onClick={handleOpenRefModal}>
                    {t`Referrals`}
                </button>
            </div>

            {/* Список подключённых счетов */}
            <div className="trade-block t-forex-accounts">
                <div className="t-block-title">{t`Connected accounts`}</div>
                {loadingForex ? (
                    <div className="t-forex-loading">{t`Loading...`}</div>
                ) : forexAccounts.length === 0 ? (
                    <div className="t-forex-empty">{t`No connected accounts`}</div>
                ) : (
                    forexAccounts.map((acc) => (
                        <div key={acc.id} className={`t-forex-account-item t-status-${acc.status || 'pending'}`}>
                            <div className="t-forex-account-info">
                                {getStatusIcon(acc.status)}
                                <span className="t-forex-account-number">{acc.account_number}</span>
                            </div>
                            <div className="t-forex-account-actions">
                                <span className="t-forex-account-status-text">{getStatusText(acc.status)}</span>
                                <button
                                    className="t-forex-delete-btn"
                                    onClick={() => handleDeleteAccount(acc.id, acc.account_number)}
                                    title={t`Delete`}
                                >
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ff4d4d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <polyline points="3 6 5 6 21 6" />
                                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                                        <line x1="10" y1="11" x2="10" y2="17" />
                                        <line x1="14" y1="11" x2="14" y2="17" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    ))
                )}
            </div>

            {/* Блок добавления счёта */}
            <div className="trade-block t-forex-add-block">
                <div className="t-block-title">{t`Add account`}</div>
                <div className="t-forex-add-row">
                    <input
                        className="t-forex-input"
                        type="text"
                        placeholder={t`Account number`}
                        value={newAccount}
                        onChange={(e) => setNewAccount(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && handleAddAccount()}
                    />
                    <button className="t-action-button t-forex-add-btn" onClick={handleAddAccount}>
                        {t`Add`}
                    </button>
                </div>
            </div>
        </div>
    );

    const referralsModal = showRefModal && (
        <div className="t-modal-overlay" onClick={() => setShowRefModal(false)}>
            <div className="t-modal-container" onClick={(e) => e.stopPropagation()}>
                <div className="t-modal-header">
                    <div className="t-modal-title">{t`Referrals`}</div>
                    <button className="t-modal-close-btn" onClick={() => setShowRefModal(false)}>&times;</button>
                </div>

                <div className="t-date-filter-container">
                    <div className="t-date-group">
                        <label className="t-date-label">{t`From`}</label>
                        <input
                            type="date"
                            className="t-date-input"
                            value={refDateFrom}
                            onChange={(e) => setRefDateFrom(e.target.value)}
                        />
                    </div>
                    <div className="t-date-group">
                        <label className="t-date-label">{t`To`}</label>
                        <input
                            type="date"
                            className="t-date-input"
                            value={refDateTo}
                            onChange={(e) => setRefDateTo(e.target.value)}
                        />
                    </div>
                    <button className="t-filter-btn" onClick={() => fetchReferrals(refDateFrom, refDateTo)}>
                        {t`Apply`}
                    </button>
                </div>

                {refData && refData.totalCommission !== undefined && (
                    <div className="t-summary-card">
                        <span className="t-summary-label">{t`Total Commission`}:</span>
                        <span className="t-summary-value">
                            {formatNumberWithCommas(refData.totalCommission, 2)} {refData.currency || 'USDT'}
                        </span>
                    </div>
                )}

                <div className="t-referrals-table-wrapper">
                    {refLoading ? (
                        <div className="t-forex-loading">{t`Loading...`}</div>
                    ) : refError ? (
                        <div className="t-forex-empty">{refError}</div>
                    ) : !refData || !refData.referrals || refData.referrals.length === 0 ? (
                        <div className="t-forex-empty">{t`No referral data available`}</div>
                    ) : (
                        <table className="t-ref-table">
                            <thead>
                                <tr>
                                    <th>{t`Referral`}</th>
                                    <th style={{ textAlign: 'center' }}>{t`Line`}</th>
                                    <th style={{ textAlign: 'right' }}>{t`Commission`}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {refData.referrals.map((item, index) => (
                                    <tr key={item.id || index}>
                                        <td>{item.referral || item.username || item.id}</td>
                                        <td style={{ textAlign: 'center' }}>{item.line || item.level || 1}</td>
                                        <td style={{ textAlign: 'right' }} className="t-ref-commission">
                                            {formatNumberWithCommas(item.commission, 2)} {refData.currency || 'USDT'}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );

    return (
        <>
            {tabs}
            {activeTab === 'crypto' && <>{bal} {parseFloat(recData.trade_balance) !== 0 && stat} {trd}</>}
            {activeTab === 'forex' && forexContent}
            {referralsModal}
        </>
    );
}

export { Trade };